export enum ContentType {
    MOVIE = 'movie',
    TV_SHOW = 'tv',
}
